import React, { createContext, useContext, useState, useRef } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

const ConfirmationServiceContext = createContext();

export const useConfirmation = () => useContext(ConfirmationServiceContext);

export const ConfirmationServiceProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const optionsRef = useRef({});

  const confirm = (options) => {
    optionsRef.current = options;
    setVisible(true);
  };

  const onHide = () => {
    setVisible(false);
  };

  const accept = () => {
    if (optionsRef.current.accept) {
      optionsRef.current.accept();
    }
    onHide();
  };

  const reject = () => {
    if (optionsRef.current.reject) {
      optionsRef.current.reject();
    }
    onHide();
  };

  const { message, header, icon, acceptLabel, rejectLabel } = optionsRef.current;

  return (
    <>
      <ConfirmationServiceContext.Provider value={{ confirm }}>
        {children}
      </ConfirmationServiceContext.Provider>
      <ConfirmDialog
        visible={visible}
        onHide={onHide}
        message={message}
        header={header}
        icon={icon || 'pi pi-exclamation-triangle'}
        accept={accept}
        reject={reject}
        acceptLabel={acceptLabel || 'Yes'}
        rejectLabel={rejectLabel || 'No'}
      />
    </>
  );
}; 